import { useMemo } from "react";
import type { UserMenusType } from "~/components/blocks/layout/global-navi/const/user-menus";
import { USER_TYPES } from "~/components/blocks/layout/global-navi/const/user-menus";
import { G_ServicePlan } from "~/lib/graphql";

type UseServicePlanArgs = {
  isLoggedIn: boolean;
  servicePlan?: G_ServicePlan;
};

export const useServicePlan = ({ isLoggedIn, servicePlan }: UseServicePlanArgs) => {
  const userMenuType: UserMenusType = useMemo(() => {
    if (servicePlan === undefined || !isLoggedIn) return USER_TYPES.GUEST;
    return servicePlan === G_ServicePlan.Premium ? USER_TYPES.PREMIUM : USER_TYPES.FREE;
  }, [isLoggedIn, servicePlan]);

  return {
    /** サービスプランに応じたuser menuのリストのkey */
    userMenuType,
  };
};
